<template>
  <div>
    <!-- 底部联系与版权区 -->
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-left">
          <div class="contact-item">
            <Icon type="ios-telephone"></Icon>
            <span>服务热线：{{configObj.serviceHotline || '--'}}</span>
          </div>
          <div class="qrcode-wrapper">
            <div class="qrcode">
              <img :src="configObj.contactImage1 | qiniuResource"/>
            </div>
            <div class="qrcode">
              <img :src="configObj.contactImage2 | qiniuResource"/>
            </div>
          </div>
        </div>
        <div class="footer-right">
          <div class="contact-title">
            <Icon type="ios-telephone"></Icon>
            <span>联系方式</span>
          </div>
          <div class="contact-info">
            <p><i class="fas fa-phone-alt"></i> 电话：{{configObj.contactCellphone || '--'}}</p>
            <p><i class="fas fa-envelope"></i> 邮箱：{{configObj.contactEmail || '--'}}</p>
            <p><i class="fas fa-map-marker-alt"></i> 地址：{{configObj.fullAddress || '--'}}</p>
          </div>
        </div>
      </div>
      <div class="footer-copyright">
        {{ configObj.copyright || '--' }}
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: ['configObj'],
  data () {
    return {
      
    };
  }
};
</script>

<style scoped>
/* ========== Footer ========== */
.footer {
  background: #E50012;
  color: white;
  padding: 30px 0 20px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  margin-bottom: 50px;
}

.footer-left {
  padding: v30px;
}

.contact-item {
  font-size: 18px;
  margin-bottom: 20px;
}

.contact-item i {
  font-size: 20px;
  margin-right: 10px;
}

.qrcode-wrapper {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.qrcode {
  width: 120px;
  height: 120px;
}
.qrcode img{
    width: 100%;
    height: 100%;
}

.footer-right {
  padding: 20px;
}

.contact-title {
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 600;
}

.contact-title i {
  font-size: 20px;
  margin-right: 10px;
}

.contact-info p {
  margin-bottom: 20px;
  font-size: 16px;
}

.contact-info i {
  width: 20px;
  color: white;
  opacity: 0.8;
}

.footer-copyright {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 16px;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .qrcode {
    width: 80px;
    height: 80px;
  }

  .footer-container {
    grid-template-columns: 1fr;
    margin-bottom: 10px;
  }

  .footer-right{
    padding: 0;
  }

  .contact-item {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .contact-item i {
    font-size: 14px;
    margin-right: 5px;
  }

  .contact-info p {
    font-size: 14px;
  }

  .footer-copyright {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue